<template>
    <rotate3DCard trigger="custom" direction="row" v-model="showVisible">
        <template v-slot:front>
            <div class="ringPage dialog-custom-class">
                <div class="panel-header">
                    <div class="leftNav">
                        <div class="icg" :style="{ backgroundColor: deviceData.online ?  '#05d41b': '#666666'}"></div>
                        <div class="status_des" v-if="deviceData.online">{{ $t('ems.online') }}</div>
                        <div class="status_des" v-else>{{ $t('ems.offline') }}</div>
                        <span :class="['iconfont', iconOptionF(ringData.envIcon)]"></span>
                    </div>
                    <div class="centerNav">{{language == 'zh' ?  ringData.envName : ringData.envNameEn }}</div>
                    <div class="rightNav">
                        <span class="iconfont icon-guanli" @click=" onOpenSet()" v-if="ringData.backPage.length > 0"></span>
                    </div>
                </div>
                <div class="panel-content">
                    <div class="panel-show">
                        <div class="container" v-if="ringData.frontPage && (ringData.frontPage.length > 1 || (ringData.frontPage.length === 1 && ringData.frontPage[0].type === 2))">
                            <template v-for="(item, index) in ringData.frontPage">
                                <div class="showItem" :key="index">
                                    <div class="breakerItem" >
                                        <div class="breakerItemtext">{{item.name}}</div>
                                        <template v-if="item.readIdentifier && item.readTag && deviceData.data">
                                            <div class="icg" :style="{ color:writeColorFormat(deviceData.data[item.readTag], item) }">{{ writeFormat(deviceData.data[item.readTag], item)}}<span class="unit" >{{item.unit ? item.unit : '&nbsp;&nbsp;'}}</span> </div>
                                        </template>
                                    </div>
                                    <div class="breakerItem tableSearchForm" style="padding: 0" v-if="item.type == 2">
                                        <el-select v-model="item.btnInputDefault" popper-class="selectDown" style="flex: 1; margin-right: 10px" size="mini" v-if="item.writeType == 3">
                                            <el-option :value="itm.value" :label="itm.key" v-for="(itm, idx) in item.readDict" :key="idx"></el-option>
                                        </el-select>
                                        <el-input size="mini" v-model="item.btnInputDefault" v-else-if="item.writeType == 2 && item.writeInputType == 0" style="flex: 1; margin-right: 10px"></el-input>
                                        <el-input size="mini" v-model="item.btnInputDefault" v-else-if="item.writeType == 2 && item.writeInputType == 1" style="flex: 1; margin-right: 10px"></el-input>
                                        <div style="flex: 1; margin-right: 10px" v-else></div>
                                        <el-button size="mini" v-if="item.type == 2" style="padding: 7px" @click="handleCommand(item)">{{ language == 'zh' ?  item.btnName : item.btnNameEn }}</el-button>
                                    </div>
                                    <div class="breakerItem tableSearchForm" v-else></div>
                                </div>
                            </template>
                        </div>
                        <div class="container" v-else-if="ringData.frontPage &&  ringData.frontPage.length == 1 && ringData.frontPage[0].type === 1">
                            <div class="showItemSingle">
                                <div class="breakerItemSingle" >
                                    <template v-if="ringData.frontPage[0].readIdentifier && ringData.frontPage[0].type == 1 && deviceData.data">
                                        <div class="breakerItemtext">{{ringData.frontPage[0].name}}</div>
                                        <div class="icg" :style="{ color:writeColorFormat(deviceData.data[ringData.frontPage[0].readTag], ringData.frontPage[0]) }">{{ writeFormat(deviceData.data[ringData.frontPage[0].readTag], ringData.frontPage[0])}}<span class="unit" >{{ringData.frontPage[0].unit ? ringData.frontPage[0].unit : '&nbsp;&nbsp;'}}</span> </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel-tools">
                    <div class="control">
                        {{ deviceData.collectTime | nullFormat}}
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:back>
            <div class="ringPage dialog-custom-class">
                <div class="panel-header">
                    <div class="leftNav">
                        <div class="icg" :style="{ backgroundColor: deviceData.online ?  '#05d41b': '#666666'}"></div>
                        <div class="status_des" v-if="deviceData.online">{{ $t('ems.online') }}</div>
                        <div class="status_des" v-else>{{ $t('ems.offline') }}</div>
                        <span :class="['iconfont', iconOptionF(ringData.envIcon)]"></span>
                    </div>
                    <div class="centerNav">{{language == 'zh' ?  ringData.envName : ringData.envNameEn }}</div>
                    <div class="rightNav">
                        <span class="iconfont icon-guanli" @click="onOpenSet(false)"></span>
                    </div>
                </div>
                <div class="panel-content">
                    <div class="panel-show">
                        <div class="container" v-if=" ringData.backPage && (ringData.backPage.length > 1 || (ringData.backPage.length === 1 && ringData.backPage[0].type === 2))">
                            <template v-for="(item, index) in ringData.backPage">
                                <div class="showItem" :key="index">
                                    <div class="breakerItem" >
                                        <div class="breakerItemtext">{{item.name}}</div>
                                        <template v-if="item.readIdentifier && item.readTag && deviceData.data">
                                            <div class="icg" :style="{ color:writeColorFormat(deviceData.data[item.readTag], item) }">{{ writeFormat(deviceData.data[item.readTag], item)}}<span class="unit" >{{item.unit ? item.unit : '&nbsp;&nbsp;'}}</span> </div>
                                        </template>
                                    </div>
                                    <div class="breakerItem tableSearchForm" style="padding: 0" v-if="item.type == 2">
                                        <el-select v-model="item.btnInputDefault" popper-class="selectDown" style="flex: 1; margin-right: 10px" size="mini" v-if="item.writeType == 3">
                                            <el-option :value="itm.value" :label="itm.key" v-for="(itm, idx) in item.readDict" :key="idx"></el-option>
                                        </el-select>
                                        <el-input size="mini" v-model="item.btnInputDefault" v-else-if="item.writeType == 2 && item.writeInputType == 0" style="flex: 1; margin-right: 10px"></el-input>
                                        <el-input size="mini" v-model="item.btnInputDefault" v-else-if="item.writeType == 2 && item.writeInputType == 1" style="flex: 1; margin-right: 10px" ></el-input>
                                        <div style="flex: 1; margin-right: 10px" v-else></div>
                                        <el-button size="mini" v-if="item.type == 2" style="padding: 7px" @click="handleCommand(item)">{{ language == 'zh' ?  item.btnName : item.btnNameEn }}</el-button>
                                    </div>
                                    <div class="breakerItem tableSearchForm" v-else></div>
                                </div>

                            </template>
                        </div>
                        <div class="container" v-else-if="ringData.backPage &&  ringData.backPage.length == 1 && ringData.backPage[0].type === 1">
                            <div class="showItemSingle">
                                <div class="breakerItemSingle" >
                                    <div class="breakerItemtext">{{ringData.backPage[0].name}}</div>
                                    <template v-if="ringData.backPage[0].readIdentifier && ringData.backPage[0].readTag && deviceData.data">
                                        <div class="icg" :style="{ color:writeColorFormat(deviceData.data[ringData.backPage[0].readTag], ringData.frontPage[0]) }">{{ writeFormat(deviceData.data[ringData.backPage[0].readTag], ringData.backPage[0])}}<span class="unit" >{{ringData.backPage[0].unit ? ringData.backPage[0].unit : '&nbsp;&nbsp;'}}</span> </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel-tools">
                    <div class="control">
                        {{ deviceData.collectTime | nullFormat}}
                    </div>
                </div>
            </div>
        </template>
    </rotate3DCard>
</template>

<script>
    import rotate3DCard from "./rotate3DCard";
    import {mapGetters} from "vuex";
    import { sendControl } from  "@/api/spms";
    import i18n from "@/lang";

    export default {
        name: "RingSingle",
        components: {rotate3DCard},
        props: ['ringData', 'deviceData'],
        data() {
            return {
                deviceNo: '',
                currentIndex: 0,
                showVisible: true,
            };
        },
        computed: {
            ...mapGetters(["language"]),
        },
        filters: {
            nullFormat(val) {
                if (val === null || val === undefined) {
                    return "--"
                } else {
                    return val
                }
            },
        },
        created(){

        },
        mounted() {
            setTimeout(() => {
                console.log(this.ringData.frontPage)
            }, 200)
        },
        destroyed() {
        },
        methods: {
            onChangeTab(item) {
                this.currentIndex = item;
            },
            onOpenSet() {
                this.showVisible = !this.showVisible;
            },

            iconOptionF(val){
                const temp = [
                    { name: '默认', value: 'icon-kongzhiqi'},
                    { name: '空调', value: 'icon-kongtiao'},
                    { name: '消防', value: 'icon-xiaofangzhuji'},
                    { name: '水浸', value: 'icon-shuijin'},
                    { name: 'UPS', value: 'icon-dianyuan'},
                    { name: '液冷机', value: 'icon-lengqueshuinengliang'},
                ];
                return temp[val].value
            },

            writeFormat(val, item){
                if(val == null || val == undefined ||  val === "" ){
                    return '--';
                }
                if((item.type === 1 && item.hasDict) || (item.type === 2 && item.writeType === 3)){
                    const temp = item.readDict.find(i => i.value == val );
                    if(temp){
                        return  temp.key;
                    }else{
                        return '--';
                    }
                }
                return val;
            },

            writeColorFormat(val, item){
                if(val == null || val == undefined ||  val === "" ){
                    return '';
                }
                if((item.type === 1 && item.hasDict) || (item.type === 2 && item.writeType === 3)){
                    const temp = item.readDict.find(i => i.value == val );
                    if(temp && temp.color ){
                        return  temp.color;
                    }else{
                        return '';
                    }
                }
                return val;
            },

            handleCommand(item){
                const params = {
                    "deviceNo": this.deviceData.deviceNo,
                    "propertyName": item.name,
                    "propertyNameEn": item.nameEn,
                    "identifier": item.writeIdentifier,
                    "tagNo": item.writeTag,
                    "value": item.btnInputDefault,
                };
                this.$confirm("确定下发此命令吗？", {
                    confirmButtonText: i18n.t("ems.strategy.confirm"),
                    cancelButtonText:  i18n.t("ems.strategy.cancel"),
                    type: "warning"
                }).then(() => {
                    sendControl(params).then(res =>  {
                        if(res && res.data && res.data.success){
                            this.$message.success("下发成功！");
                        }else{
                            this.$message.success("下发失败！");
                        }
                    }).catch(err => {
                        this.$message.error(err)
                    });
                }).then(() => {
                });
            }
        },
    };
</script>

<style scoped lang="scss">
    @import "@/styles/common";

    /deep/ .el-input-number__decrease {
        background: #141414 !important;
    }

    /deep/ .el-input-number__increase {
        background: #141414 !important;
    }

    /deep/ .el-input-number.is-controls-right .el-input-number__increase {
        border-bottom: 1px solid #595959 !important;
        box-sizing: border-box;
    }

    /deep/ .el-input-number.is-controls-right .el-input-number__decrease {
        border-left: 1px solid #595959 !important;
        box-sizing: border-box;
    }

    /deep/ .el-input-number__increase {
        border-left: 1px solid #595959 !important;
        box-sizing: border-box;
    }

    /deep/ .el-radio__inner {
        border: 1px solid #a6a6a6;
        background-color: #a6a6a6;
        box-sizing: border-box;
    }

    /deep/ .el-radio__input.is-checked .el-radio__inner {
        border-color: #00c5d1 !important;
        background: #00c5d1 !important;
        box-sizing: border-box;
    }

    /deep/ .el-radio__label {
        color: #a6a6a6;
    }

    /deep/ .el-radio__input.is-checked + .el-radio__label {
        color: #00c5d1 !important;
    }

    /deep/ .el-radio-group {
        background-color: #0d0d0d !important;
        padding: 8px;
        width: 270px;
        border: 1px solid #595959;
        box-sizing: border-box;
    }

    .ringPage {
        width: 100%;
        height: 100%;
        position: relative;
        background-color: var(--container_env_bg);
        z-index: 99;
        display: flex;
        border: none !important;
        flex-direction: column;
        box-sizing: border-box;

        .panel-header {
            height: 60px;
            line-height: 60px;
            box-sizing: border-box;
            background-color: var(--site_box_bg);
            display: flex;
            justify-content: space-around;
            .leftNav {
                width: 20%;
                text-align: left;
                position: relative;

                .iconfont {
                    color: $label_font_active;
                    font-size: 40px;
                    padding-left: 10px;
                }

                .icg {
                    height: 12px;
                    width: 12px;
                    position: absolute;
                    top: 20px;
                    right: 8px;
                    border-radius: 50%;
                }

                .status_des {
                    position: absolute;
                    color: var(--fontblue);
                    font-size: 12px;
                    top: 12px;
                    right: 0px;
                }
            }

            .centerNav {
                width: 50%;
                text-align: center;
                font-size: 26px;
                color: $label_font_active;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .rightNav {
                width: 20%;
                text-align: right;

                .iconfont {
                    color: $label_font_active;
                    font-size: 30px;
                    padding-right: 20px;
                    cursor: pointer;
                    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                }
            }
        }

        .panel-content {
            flex: 1;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
            box-sizing: border-box;

            .panel-show {
                height: 100%;
                width: 100%;
                box-sizing: border-box;
                display: flex;
                justify-content: center;
                align-items: center;
                .container {
                    width: 410px;
                    max-height: 290px;
                    overflow-y: auto;
                    display: flex;
                    /*background-color: #1c1c1c;*/
                    font-size: 16px;
                    justify-content: center;
                    flex-wrap: wrap;
                    .showItem{
                        margin-bottom: 5px;
                        background-color: var(--ringBg);
                        padding: 6px;
                        box-sizing: border-box;
                        width: 198px;
                    }
                    .showItem:nth-child(odd){
                        margin-right: 5px;
                    }

                    .showItemSingle{
                        background-color: var(--ringBg);
                        padding: 10px;
                        box-sizing: border-box;
                        width: 260px;
                    }
                    .breakerItem{
                        height: 40px;
                        padding: 0 10px;
                        display: flex;
                        align-items: center;
                        color: $label_font_active;
                        font-size: 18px;
                        justify-content: space-between;
                        .icg{
                            font-size: 18px;
                            /*max-width: 60px;*/
                            color: var(--ringValue);
                        }
                        .breakerItemtext{
                            max-width: 110px;
                            color: var(--ringTitle);
                        }
                        .unit{
                            font-size: 14px;
                            color: var(--ringUnit);
                            padding-left: 10px;
                        }
                    }

                    .breakerItemSingle{
                        height: 80px;
                        padding: 0 10px;
                        display: flex;
                        align-items: center;
                        color: $label_font_active;
                        justify-content: space-between;
                        font-size: 26px;

                        .icg{
                            font-size: 26px;
                            /*max-width: 60px;*/
                            color: var(--ringValue);
                        }
                        .breakerItemtext{
                            max-width: 110px;
                            color: var(--ringTitle);
                        }
                        .unit{
                            font-size: 18px;
                            color: var(--ringUnit);
                            padding-left: 10px;
                        }
                    }
                }
            }
        }

        .panel-tools {
            height: 40px;
            background-color: var(--site_box_bg);
            display: flex;
            justify-content: flex-end;
            box-sizing: border-box;
            padding: 0 15px;
            .title {
                color: var(--fontblue);
                font-size: 18px;
                line-height: 50px;
                height: 50px;
            }

            .control {
                display: flex;
                align-items: center;
                font-size: 14px;
                color: $label_font_active;
            }
        }
    }
</style>
